export default __webpack_public_path__ + "static/media/coverrock-x-2-rockwool-platte_comp.85938e4c.jpg";